import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/components/Button';
import SignUpModal from 'flarum/components/SignUpModal';

export default class WeappLoginModal extends Modal {

    
    oncreate(node){
    	super.oncreate(node);
    	this.qrcodeSrc = false;
    	this.loadQrcode(node.attrs.isMp);
    }
    
    
    loadQrcode(isMp){
        this.isMp = isMp;
        app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/weapp/qrcode?isMp='+ (this.isMp?1:0)
        }).then((data) => {
            this.qrcodeSrc = data.src;
            this.token = data.token;
            m.redraw();
            clearInterval(app.mp_interval);
            app.mp_interval = setInterval(()=>{this.checkLogin(data.token)}, 2000);
        });
    }
    
    checkLogin(token){
        app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/weapp/check-login',
            body: {"token":token,isMp:this.isMp},
        }).then((data) => {
            if(data.complete){
                window.location.reload();
            }
        });
    }
    
    className() {
        return 'AuthWeChatLinkModal Modal--small';
    }

    title() {
        return this.isMp?app.translator.trans('sayiwen-auth-wechat.forum.buttons.link_mp'):app.translator.trans('sayiwen-auth-wechat.forum.buttons.login');
    }
    
    content() {
        return (
            <div className="Modal-body">
                <div className="Form Form--centered">
                    <div className="Form-group">
                        {this.qrcodeSrc?<img className="WeappQrcode" src={this.qrcodeSrc}/> : ''}
                    </div>
                </div>
            </div>
        );
    }
}